import { FC } from 'react';
import { Stack, Text, Button } from '@chakra-ui/react';
import { WarningCircleIcon } from '@phosphor-icons/react';

interface ChartErrorStateProps {
  onRetry: () => void;
  message?: string;
}

export const ChartErrorState: FC<ChartErrorStateProps> = ({ onRetry, message }) => {
  const subtitle = message
    ? message.length > 80 ? message.slice(0, 80) + '…' : message
    : 'Riprova più tardi';

  return (
    <Stack align="center" justify="center" gap={2} py={6} px={4} textAlign="center">
      <WarningCircleIcon size={28} color="var(--c-error)" weight="fill" />
      <Text fontSize="13px" fontWeight="600" style={{ color: 'var(--c-text-0)' }}>
        Impossibile caricare i dati
      </Text>
      <Text fontSize="12px" style={{ color: 'var(--c-text-1)' }}>
        {subtitle}
      </Text>
      <Button
        size="sm"
        variant="outline"
        onClick={onRetry}
        mt={1}
        style={{ borderColor: 'var(--c-text-0)', color: 'var(--c-text-0)', fontSize: '12px', height: '30px' }}
      >
        Riprova
      </Button>
    </Stack>
  );
};
